import React from 'react'

const NodataYet = ({message, customeHight = '300px'}: any) => {
  return (
    <div className={`card mt-5 w-355px h-${customeHight} px-10 py-10`}>
      <div className='row align-items-center'>
        <div className='col-md-6'>
        </div>
        <div className='col-md-6 text-end'>

        </div>
        <div className='No_data'>
          <div className='single_data'>{message || 'No data yet'}</div>
        </div>
      </div>
    </div>
  )
}

export default NodataYet
